package com.milta.core.localization.translations.bg

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Импортиране — Снимка",
    titlePdf = "Импортиране — PDF",
    titleSpreadsheet = "Импортиране — Excel / CSV",
    fileSentSuffix = "изпратено току-що",
    fileWaitingConnectionLabel = "изчаква връзка",
    analysingTitle = "Четене на документа…",
    analysingSubtitle = "Извличането на доставките може да отнеме няколко секунди.",
    analysingSubtitlePdf = "Claude Haiku извлича доставките — това може да отнеме няколко секунди при сканиран PDF.",
    stepFileSent = "Файлът е изпратен",
    stepExtracting = "Извличане на полетата",
    stepReview = "Преглед преди добавяне",
    successTitle = "Доставка открита",
    successSubtitle = "Проверете информацията, преди да я добавите към маршрута.",
    addToRouteButton = "Добави към маршрута",
    scanAnotherButton = "Сканирай друг документ",
    partialTitle = "Почти завършено",
    partialSubtitle = "Едно поле не можа да бъде прочетено от документа.",
    missingFieldPlaceholder = "Да се попълни…",
    partialBannerText = "Част от информацията не можа да бъде прочетена. Можете да потвърдите както е и да я допълните по-късно, или да изпратите по-ясен документ.",
    retryFileButton = "Изпрати друг файл",
    validateAndContinueButton = "Потвърди и продължи",
    attemptLabel = "Опит",
    errorTitleUnreadable = "Нечетим документ",
    errorTitleMissingFields = "Информацията не е намерена",
    errorTitleNetworkError = "Проблем при анализа",
    errorTitleGeneric = "Анализът неуспешен",
    errorSubtitle = "Не успяхме да открием доставка в този файл.",
    errorBannerSuffixUnreadable = "изображението е твърде тъмно или текстът е отрязан. Направете добре кадрирана и добре осветена снимка или изпратете по-ясен файл.",
    errorBannerSuffixMissingFields = "не беше намерена полезна информация. Проверете съдържанието на файла или изпратете друг.",
    errorBannerSuffixNetworkError = "услугата за анализ срещна мрежов проблем. Опитайте отново след малко.",
    errorBannerSuffixGeneric = "възникна неочаквана грешка по време на анализа. Опитайте отново или изпратете друг файл.",
    retryWithNewFileButton = "Опитай отново с друг файл",
    manualEntryButton = "Въведи ръчно",
    attemptsRemainingNote = "Остава ви 1 опит за този документ.",
    maxAttemptsTitle = "Все още нечетим",
    maxAttemptsSubtitle = "Този документ не можа да бъде прочетен след 2 опита.",
    maxAttemptsBanner = "Достигнат е лимитът от опити за този документ. Попълнете доставката ръчно или започнете нов импорт с нов документ.",
    retryUnavailableButton = "Опитай отново — недостъпно",
    newDocumentButton = "Импортирай нов документ",
    serviceUnavailableTitle = "Услугата временно недостъпна",
    serviceUnavailableSubtitle = "Автоматичният анализ не отговаря в момента.",
    serviceUnavailableBanner = "Опитайте отново след малко или попълнете доставката ръчно междувременно.",
    offlineTitle = "Вие сте офлайн",
    offlineSubtitle = "Вашият файл е готов, но все още не е изпратен.",
    offlineBanner = "Свържете се отново с интернет и стартирайте анализа отново. Нищо не е изпратено към сървъра — не е отчетен опит.",
    retryOfflineButton = "Опитай отново — няма връзка",
    unsupportedFormatBanner = "Неподдържан формат на файл. Изберете снимка, PDF или Excel/CSV файл.",
    validationTitle = "Прегледайте доставките",
    fileRejectedTitle = "Файлът не е изпратен",
    fileRejectedSubtitle = "Изберете друг файл, за да продължите.",
    bannerFileRequired = "не е избран файл. Изберете PDF файл, за да продължите.",
    bannerInvalidPdfFormat = "неподдържан формат. Тук се приемат само PDF файлове.",
    bannerFileTooLarge = "файлът е твърде голям. Изберете по-лек PDF файл.",
    chooseAnotherFileButton = "Избери друг файл",
)
